export default __webpack_public_path__ + "static/media/rocko.99a29b31.png";